import axios from 'axios';
import { createErrorObject } from './errorHandler';

const PRODUCT_STORE_SERVER = import.meta.env.VITE_PRODUCT_STORE_SERVER;
const apiInstance = axios.create();
const makeAPIRequest = async (method, url, data, config = {}) => {
  const finalUrl = `${PRODUCT_STORE_SERVER}${url}`
  try {
    const response = await apiInstance({ method, url:finalUrl, data, ...config });
    return response.data;
  } catch (error) {
    throw createErrorObject(error);
  }
};

const getFeatureById = async (id) => {
  if (!id) {
    return;
  }

  const url = `/feature/${id}`;
  return makeAPIRequest('get', url);
};


export { getFeatureById};
